import styled from 'styled-components'

export const Flex = styled.div`
  display: flex;
  align-items: center;      
  // font-size:2rem;
  & > div,
  & > iframe,
  & > ul {
    flex: 1;
  }
  @media (max-width: ${({ theme }) => theme.mobile}) {
    flex-direction: column;
    text-align: center;
  }
`;